<template>
  <SalesRegisterTableCard :is-empty="! tableItems.length" :is-loaded="isLoaded">
    <table class="table register-table">
      <thead>
      <tr>
        <th>Sl</th>
        <th>Date</th>
        <th>Invoice Number</th>
        <th v-if="false">Invoice Type</th>
        <th v-if="false">Order Type</th>
        <th v-if="contactName">Client Name</th>
        <th v-if="hasBusinessName">Business Unit</th>
        <th v-if="salePersonName">Sales Person</th>
        <th class="num">Invoice Amount</th>
        <th class="num">VAT Amount</th>
        <th class="num">Total Amount</th>
        <th class="num">Discount Amount</th>
        <th class="num">Redeem Point</th>
        <th class="num">Net Bill Amount</th>
        <th class="num">Paid Amount</th>
        <th class="num">Due Amount</th>
        <th class="num">Item Wise Discount</th>
        <th class="num">Total Invoice Amount(After Item Dis)</th>
        <th class="num">COGS</th>
        <th class="num">Gross Profit</th>
        <th class="num">Setl. Discount</th>
        <th class="num">Profit After Discount</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, i) in tableItems" :key="i">
        <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
        <td class="text-nowrap">{{ item.date }}</td>
        <td class="text-nowrap">{{ item.bill_number }}</td>
        <td v-if="false">{{ item.invoice_type }}</td>
        <td v-if="false">{{ item.sales_order_master ? item.sales_order_master.sale_type_title : '' }}</td>
        <td v-if="contactName">{{ item.contact_name }}</td>
        <td v-if="hasBusinessName">{{ item.business_name }}</td>
        <td v-if="salePersonName">{{ item.sr_name }}</td>
        <td class="num">{{ item.subtotal_amount ? commaFormat(item.subtotal_amount) : '' }}</td>
        <td class="num">{{ item.vat_amount ? commaFormat(item.vat_amount) : '' }}</td>
        <td class="num">{{ commaFormat((item.subtotal_amount ?? 0) + (item.vat_amount ?? 0)) }}</td>
        <td class="num">{{ item.total_discount ? commaFormat(item.total_discount) : '' }}</td>
        <td class="num">{{ item.points_redeemed ? commaFormat(item.points_redeemed) : '' }}</td>
        <td class="num">{{ item.total_amount ? commaFormat(item.total_amount) : '' }}</td>
        <td class="num">{{ item.paid_amount ? commaFormat(item.paid_amount) : '' }}</td>
        <td class="num">{{ getTotalDue(item) ? commaFormat(getTotalDue(item)) : '' }}</td>
        <td class="num">{{ item.item_wise_discount ? commaFormat(item.item_wise_discount) : '' }}</td>
        <td class="num">{{ commaFormat((item.subtotal_amount ?? 0) + (item.vat_amount ?? 0) - (item.item_wise_discount ?? 0)) }}</td>
        <td class="num">{{ item.stocks_sum_stock_value ? commaFormat(item.stocks_sum_stock_value) : '' }}</td>
        <td class="num">{{ item.stocks_sum_profit_value ? commaFormat(item.stocks_sum_profit_value) : '' }}</td>
        <td class="num">{{ item.round_up_discount ? commaFormat(item.round_up_discount) : '' }}</td>
        <td class="num">{{ commaFormat(item.stocks_sum_profit_value - item.round_up_discount) }}</td>
      </tr>
      </tbody>
      <tfoot v-if="isLastPage">
      <tr>
        <td colspan="3" class="register-total-label">Total</td>
        <td v-if="hasBusinessName"></td>
        <td v-if="salePersonName"></td>
        <td v-if="contactName"></td>
        <td class="num">{{ totalValue && totalValue.total_subtotal_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_vat_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_sum_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_discount }}</td>
        <td class="num">{{ totalValue && totalValue.total_points_redeemed }}</td>
        <td class="num">{{ totalValue && totalValue.total_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_paid_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_due_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_item_wise_discount }}</td>
        <td class="num">{{ totalValue && totalValue.total_item_wise_amount }}</td>
        <td class="num">{{ totalValue && totalValue.total_stock_value }}</td>
        <td class="num">{{ totalValue && totalValue.total_profit_value }}</td>
        <td class="num">{{ totalValue && totalValue.total_round_up_discount }}</td>
        <td class="num">{{ totalValue && totalValue.total_profit_discount }}</td>
      </tr>
      </tfoot>
    </table>
  </SalesRegisterTableCard>
</template>

<script setup>
import { computed } from 'vue'
import figureFormatter from '@/services/utils/figureFormatter'
import SalesRegisterTableCard from '@/components/molecule/company/inventory/product-sales-register/SalesRegisterTableCard.vue'

const { commaFormat } = figureFormatter()

const props = defineProps({
  tableItems: {
    type: Array
  },
  currentPage: Number,
  lastPage: Number,
  perPage: Number,
  totalValue: Object,
  isLoaded: {
    type: Boolean,
    default: true
  }
})

const isLastPage = computed(() => {
  if (! props.tableItems.length) return false
  return props.currentPage === props.lastPage
})

const hasBusinessName = computed(() => {
  return props.tableItems.some(item => item.business_name && item.business_name.trim() !== '')
})

const salePersonName = computed(() => {
  return props.tableItems.some(item => item.sr_name && item.sr_name.trim() !== '')
})

const contactName = computed(() => {
  return props.tableItems.some(item => item.contact_name && item.contact_name.trim() !== '')
})

const getTotalDue = (item) => {
  return parseFloat(item.total_amount) - parseFloat(item.net_receipt_amount) - parseFloat(item.ait_deducted) - parseFloat(item.vat_deducted) - parseFloat(item.discount)
}
</script>
